<!--component html goes here -->
<!-- <quill-editor #quill [(ngModel)]="value" [ngStyle]="{ 'height': _height }"></quill-editor> -->
<span *ngIf="_type === 1" class="editorCaption">{{caption}}</span>
<quill-editor *ngIf="_type === 1" #quillEditor id="quillEditor" [(ngModel)]="value" [theme]="'bubble'" [placeholder]="''"></quill-editor>

<quill-editor class="quill-basic1" *ngIf="_type === 2" #quillEditor id="quillEditor" [(ngModel)]="value" [placeholder]="''">

</quill-editor>